import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    fontSize: 10,
  },
});

export default function QtyValueTextField({ qtyBasisValue, setQtyBasisValue }) {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState(qtyBasisValue);
  useEffect(() => setInputValue(qtyBasisValue), [qtyBasisValue]);

  return (
    <>
      <TextField
        className={classes.root}
        value={inputValue}
        variant="outlined"
        size="small"
        style={{ backgroundColor: "white", width: "100%" }}
        inputProps={{ style: { fontSize: 10 } }}
        onChange={(ev) => setInputValue(ev.target.value)}
        onBlur={(ev) => setQtyBasisValue(parseFloat(ev.target.value))}
        label={<Typography style={{ fontSize: 10 }}>Qty Value</Typography>}
      >
        <Typography style={{ fontSize: 1 }}>{inputValue}</Typography>
      </TextField>
    </>
  );
}
